// src/components/WhySection.jsx
import React from 'react';
import './WhySection.css';
import reason1 from '../assets/n1.png';
import reason2 from '../assets/n2.png';
import reason3 from '../assets/n3.png';
import reason4 from '../assets/n4.png';
import reason5 from '../assets/n5.png';
import reason6 from '../assets/n6.png';

const reasons = [
  reason1, reason2, reason3,
  reason4, reason5, reason6
];

export default function WhySection() {
  const leftImages  = reasons.slice(0, 3);
  const rightImages = reasons.slice(3, 6);

  return (
    <section id="why-section" className="why-section">
      <h2>Neden Yeldeğirmeni?</h2>

      <div className="why-content">
        {/* Sol kolon */}
        <div className="images-col">
          {leftImages.map((src, i) => (
            <div key={i} className="why-item">
              <img src={src} alt={`Neden ${i + 1}`} />
            </div>
          ))}
        </div>

        {/* Metin bölümü */}
        <div className="why-description">
          <p><strong>Yaşam Alanı Olarak Okul:</strong> Yeldeğirmeni Okulları, çocukların kendilerini güvende hissettikleri ve aidiyet geliştirdikleri bir yaşam alanı sunar. Eğitimde çocukların söz hakkını önemser, evrensel ve teknolojik yaklaşımları benimser.</p>
          <p><strong>Sağlıklı Okul‑Sağlıklı Yaşam:</strong> Doğal ve hijyenik gıda sunumu, bilinçlendirme çalışmaları ve sağlıklı yaşam alışkanlıklarının erken yaşta kazandırılması hedeflenir.</p>
          <p><strong>Güçlenen Veli‑Okul İlişkisi:</strong> Veli katılımı desteklenir, okul‑ev etkileşimi güçlendirilir. Eğitimde ailenin rolü önemsenir.</p>
          <p><strong>Sorun Tanımlayıcı ve Özgürleştirici Eğitim:</strong> Sorgulayan, kendini ifade edebilen ve özgür düşünen çocuklar desteklenir. Toplumsal eşitlik anlayışı geliştirilir.</p>
          <p><strong>Süreç İçinde İlişkisel Öğrenme:</strong> Çocuklar yaşamla bütünleşik, bağlantılı öğrenme deneyimleri yaşar. Okul, canlı ve etkileşimli bir ortam sunar.</p>
          <p><strong>Demokratik Okul:</strong> Karar alma süreçlerine öğrenci, öğretmen ve velilerin katılımı teşvik edilir. Aktif bireyler olarak sorumluluk üstlenirler.</p>
          <p><strong>Ekolojik Okul:</strong> Çevreye duyarlı, sürdürülebilir yaşam becerileri kazandırılır. Açık hava dersleri, atık yönetimi ve tarım çalışmaları yapılır.</p>
          <p><strong>Öz Disiplin ve Öz Sorumluluk:</strong> Sorumluluk bilinci gelişmiş bireyler yetiştirilir. Çocuklar özgüvenli ve aktif özneler olarak büyür.</p>
          <p><strong>Çocuğun Kendi Ritmine Saygı:</strong> Her çocuğun bireysel öğrenme ritmine uyum sağlanır. Deneyim temelli öğrenme teşvik edilir.</p>
          <p><strong>Doğal Diyalog ile Güçlü İletişim:</strong> Güven dolu ortamda deneyim paylaşımı desteklenir. İletişim becerileri zengin eğitim içerikleriyle gelişir.</p>
          <p><strong>Dayanışma İlişkisi:</strong> Eğitim süreci bir yarış değil, dayanışma ile yürütülen bir yolculuktur. Çocuklar arasında destekleyici bağlar kurulur.</p>
          <p><strong>Ayrımcılığa Karşı Farkındalık:</strong> Her türlü ayrımcılığa karşı bilinç geliştirilir. Eşit toplumsal yaşam anlayışı desteklenir.</p>
          <p><strong>Oyunun Bitmediği Okul:</strong> Oyun, her yaştan çocuk için öğrenmenin ve iletişimin önemli bir aracıdır. Paylaşım ve etkileşim için aktif kullanılır.</p>
        </div>

        {/* Sağ kolon */}
        <div className="images-col">
          {rightImages.map((src, i) => (
            <div key={i} className="why-item">
              <img src={src} alt={`Neden ${i + 4}`} />
            </div>
          ))}
        </div>
      </div>

      {/* Mobilde metnin altında yatay kaydırmalı resimler */}
      <div className="images-scroll">
        {reasons.map((src, i) => (
          <div key={i} className="why-item">
            <img src={src} alt={`Neden ${i + 1}`} />
          </div>
        ))}
      </div>
    </section>
  );
}
